import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { FAQS } from '../../data/catio';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="bg-ivory py-12 sm:py-20" aria-labelledby="faq-title" data-id="element-164" data-mp="zryp56140oth">
      <div className="mx-auto grid w-full max-w-6xl gap-6 px-5 sm:px-8 lg:grid-cols-12 lg:gap-14" data-id="element-165" data-mp="uraxci5243y7">
        <div className="lg:col-span-4" data-id="element-166" data-mp="71goebnuyzj8">
          <h2 id="faq-title" className="font-display text-[1.85rem] leading-[1.12] text-ink sm:text-[2.6rem]" data-id="element-167" data-mp="22dh0kkeoh83">
            Questions Before You Build?
          </h2>
        </div>

        <ul className="divide-y divide-line border-y border-line lg:col-span-8" data-id="element-168" data-mp="bzrv4diuwtx8">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.question} data-id="element-169" data-mp="1nfqat08jie7f" data-mpi={index}>
                <h3 data-id="element-170" data-mp="1neopm2xt8bbz">
                  <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex min-h-[64px] w-full items-center justify-between gap-4 py-4 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-ember/30" data-id="element-171" data-mp="1nf6qjcvf3dq8">
                    <span className="text-[1rem] font-semibold leading-snug text-ink sm:text-[1.05rem]" data-id="element-172" data-mp="3v8m1rojlptwx">
                      {faq.question}
                    </span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-colors duration-150 ease-out ${isOpen ? 'border-ink bg-ink text-cream' : 'border-ink/20 text-ink'}`} aria-hidden data-id="element-173" data-mp="42kmf3slse5h">
                      <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-174" data-mp="3gj7po8on4ydu" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-175" data-mp="xfkamisampa7">
                  {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-176" data-mp="sfza43xh68vd">
                      <p className="max-w-2xl pb-5 pr-12 text-[0.98rem] leading-relaxed text-graphite" data-id="element-177" data-mp="9ppwzz05gwow">
                        {faq.answer}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}